import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Global axios defaults for the whole app.
axios.defaults.withCredentials = true;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Ocurrió un error. Intentá de nuevo.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) =>
                e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)
            )
            .filter(Boolean)
            .join(" · ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
